import InnerComponent from '@Components/Sales/SalesOrder/ViewSalesOrder';
import orgContainer from '@Components/AppContainer';

const ViewSalesOrder = () => ((orgContainer(InnerComponent)));
export default ViewSalesOrder;
